import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
import { computed, getCurrentInstance, ref } from "vue";
import { validatorPassWord } from "@/assets/Js/validate";
import { ElNotification } from "element-plus";
import { useStore } from "vuex";
import { useRouter } from "vue-router/dist/vue-router";

// eslint-disable-next-line no-undef

const __default__ = {
  name: "exit-password"
};
export default /*@__PURE__*/Object.assign(__default__, {
  props: {
    modelValue: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  emits: ["update:modelValue"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    // eslint-disable-next-line no-undef
    const emit = __emit;
    const open = computed({
      get: () => props.modelValue,
      set: value => emit("update:modelValue", value)
    });
    const {
        proxy
      } = getCurrentInstance(),
      that = proxy;
    const store = useStore(),
      router = useRouter();
    const validatorAgainNewPassword = (rule, value, callback) => {
      let newPassword = form.value.newPassword;
      if (newPassword === value) {
        callback();
      } else {
        callback(new Error("两次密码输入不一致"));
      }
    };
    const formRef = ref(null);
    const form = ref({
      oldPassword: "",
      newPassword: "",
      againNewPassword: ""
    });
    const checkPassword = (rule, value, callback) => {
      console.log(rule, value);
      let regex = /^(?=.*[a-zA-Z])(?=.*\d).+$/;
      if (!regex.test(value)) {
        callback(new Error('密码必须包含字母和数字'));
      } else {
        callback();
      }
    };
    const rules = {
      oldPassword: [{
        required: true,
        message: '请输入旧密码',
        trigger: 'blur'
      }, {
        min: 6,
        max: 16,
        message: '密码长度不低于6个字节且不超过16个字节',
        trigger: 'blur'
      }, {
        validator: validatorPassWord,
        trigger: "blur"
      }],
      newPassword: [{
        required: true,
        message: '请输入新密码',
        trigger: 'blur'
      }, {
        min: 6,
        max: 16,
        message: '密码长度不低于6个字节且不超过16个字节',
        trigger: 'blur'
      }, {
        validator: checkPassword,
        trigger: "blur"
      }, {
        validator: validatorPassWord,
        trigger: "blur"
      }],
      againNewPassword: [{
        validator: validatorAgainNewPassword,
        trigger: "blur"
      }, {
        validator: checkPassword,
        trigger: "blur"
      }]
    };
    const confirmFn = () => {
      formRef.value.validate((valid, fields) => {
        if (valid) {
          console.log(form.value);
          confirmAPI(form.value);
        }
      });
    };
    const confirmAPI = param => {
      that.$post("system/user/update", {
        userId: store.getters.userId,
        oldPassword: form.value.oldPassword,
        password: form.value.againNewPassword
      }).then(res => {
        if (!res) return false;
        let data_ = res.data;
        login_out();
      });

      // that.$post("system/user/updatePwd",param)
      //   .then(res => {
      //     if (!res) return false;
      //     let data_ = res.data;
      //     login_out();
      //   })
    };

    // 取消前
    const handleClose = done => {
      formRef.value.resetFields();
      done();
    };
    const cancel = () => {
      formRef.value.resetFields();
      open.value = false;
    };

    // 退出
    const login_out = () => {
      that.$post('auth/logout').then(res => {
        if (!res) return false;
        store.commit("SET_TOKEN", "");
        ElNotification.success({
          title: "密码修改成功，请重新登录！",
          customClass: "ApiMessage"
        });
        router.replace("/");
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: open.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => open.value = $event),
        title: "修改密码",
        width: "30%",
        "append-to-body": "",
        draggable: "",
        "close-on-click-modal": false,
        class: "common-dialog-class",
        "before-close": handleClose
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form.value,
          ref_key: "formRef",
          ref: formRef,
          rules: rules,
          onKeyup: _withKeys(confirmFn, ["enter"]),
          "hide-required-asterisk": "",
          "label-width": "100px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "旧密码",
            prop: "oldPassword"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.oldPassword,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.oldPassword = $event),
              type: "password",
              placeholder: "请输入",
              clearable: "",
              "show-password": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "新密码",
            prop: "newPassword"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.newPassword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.newPassword = $event),
              type: "password",
              placeholder: "请输入",
              clearable: "",
              "show-password": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "再次确认密码",
            prop: "againNewPassword",
            class: "el-form-item-end"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.againNewPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.againNewPassword = $event),
              type: "password",
              placeholder: "请输入",
              clearable: "",
              "show-password": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: cancel
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          class: "confirm-button-class",
          onClick: confirmFn
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode(" 确认 ")])),
          _: 1
        })])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});